import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { Result } from '../models/result';
import { getTotalNumberOfActiveStudents, getUsersOfClass, generateStudentPerformanceReport } from '../repositories/user/studentRepo';


const useStudentStore = create(persist(
    (set, get)=>({
        students: [],
        isStudentsLoading: false,
        totalNumberOfActiveStudents: 0,
        isTotalNumberOfActiveStudentsLoading: false,
        totalNumberOfActiveStudentsError: null,
        studentsError: null,
        isGeneratingReport: false,
        reportError: null,
        getStudentsOfClass: async (schoolId, classId, sec) => {
            set({ isStudentsLoading: true });
            const result = await getUsersOfClass(schoolId, classId, sec);
            if(result.success){
                set({ students: result.value, isStudentsLoading: false });
                
            }else{
                set({ studentsError: result.message, isStudentsLoading: false });
            }
            return result;
        },
        getTotalNumberOfActiveStudents: async (schoolId) => {
            set({ isTotalNumberOfActiveStudentsLoading: true });
            const result = await getTotalNumberOfActiveStudents(schoolId);
            if(result.success){
                set({ totalNumberOfActiveStudents: result.value, isTotalNumberOfActiveStudentsLoading: false });
            }else{
                set({ totalNumberOfActiveStudentsError: result.message, isTotalNumberOfActiveStudentsLoading: false });
            }
        },
        generateStudentPerformanceReport: async (schoolId, admissionNo) => {
            set({ isGeneratingReport: true, reportError: null });
            const result = await generateStudentPerformanceReport(schoolId, admissionNo);
            set({ isGeneratingReport: false });
            if (!result.success) {
                set({ reportError: result.message });
            }
            return result;
        },
    }),
    {
        name: 'student-storage',
        partialize: (state) => ({
            students: [],
        }),
    }
))

export default useStudentStore;